/* eslint-disable @typescript-eslint/no-var-requires */

import { quartzConfig } from 'quartz-config/evaluable';
const {
  renderApp
} = require(`./internal/${/* quartzConfig.auth */"none"}-auth-app-renderer`);
export { renderApp };